import React from "react";
import CloseIcon from "../../Layout/Icons/CloseIcon";

const UserImage = ({
  userart,
  layerId,
  imageUrl,
  selectedImageType,
  selectedId,
  handleChooseArt,
  onDelete,
  idToDelete,
}) => {
  const handleClick = () => {
    var img = new Image();
    img.src = imageUrl;

    const loaded = () => {
      img.removeEventListener('load', loaded)

      handleChooseArt({
        userart: {
          id: userart.id,
          is_active: userart.field_active,
          name: userart.field_name,
          url: imageUrl,
          width: img.naturalWidth,
          height: img.naturalHeight,
        },
        type: userart.field_type,
        layerId,
      });
    }

    img.addEventListener('load', loaded)
  };
  const handleDelete = () => {
    onDelete(userart.id);
  };

  const selected =
      userart.id === selectedId && selectedImageType === userart.field_type
        ? "selected"
        : "",
    deleting = idToDelete === userart.id ? "deleting" : "";

  return (
    <div className={`user-art__image-container ${selected} ${deleting}`}>
      <div className="button button--delete-art" onClick={handleDelete}>
        <CloseIcon />
      </div>

      <div className="user-art__image-wrap">
        <img
          className="user-art__image"
          src={`${imageUrl}?size=1`}
          alt={userart.name}
          onClick={handleClick}
        />
      </div>
    </div>
  );
};

export default UserImage;
